module.exports = __webpack_public_path__ + "img/meh.6060eb7d.svg";